export class Avatar {
  constructor() {
    this.parts = {}
    this.defaultCfg = { body: 1, eyes: 45, mouth: 44 } // "hair-1", "hair-2", "body", "hair-3", "hair-4", "ears", "eyes", "nose", "piercing", "earrings", "hat", "scars", "moles", "clothes-up", "suit", "clothes-bottom", "shoes", "accessories"
    //this.types = SKINS_TYPES
    this.cfg = { ...this.defaultCfg }
    this.element = document.getElementById("char")
    this.states = {
      default: "default.svg",
      draw: "draw.svg",
      think: "think.svg",
      win: "win.svg",
      fail: "fail.svg",
    }
    this.state = this.states.default
    //this.maxSaves = 3
    this.save = 1
    this.init()
  }

  initSettings() {
    const saved = localStorage.getItem("ava")

    if (saved && !mySkins.length) {
      const parsed = this.parse(saved)
      if (parsed) this.cfg = parsed
    } else if (mySkins && mySkins.length) {
      this.cfg = mySkins.find((skin) => skin.isActive)?.settings
    }

    this.load(this.cfg)
  }

  initProfile(data) {
    const parsed = this.parse(data)
    if (parsed) this.cfg = parsed

    this.load(this.cfg)
  }

  init() {
    /*     const saveNum = localStorage.getItem("save")
    if (saveNum != null && saveNum <= this.maxSaves) {
      this.save = saveNum
    } */
    const partsEls = this.element.querySelectorAll("div")
    partsEls.forEach((el) => {
      this.parts[el.className] = el
    })
  }

  parse(data) {
    let r = false
    try {
      const obj = JSON.parse(data)
      if (Object.keys(obj).length > 0) r = obj
    } catch (err) {
      console.log(err)
    }
    return r
  }

  isHair(str) {
    return (
      str == "hair-1" || str == "hair-2" || str == "hair-3" || str == "hair-4"
    )
  }

  load(data) {
    if (Object.keys(data).length === 0) data = this.defaultCfg
    const toRemove = Object.keys(this.cfg).filter((key) => !(key in data))
    toRemove.forEach((type) => {
      data[type] = 0
    })

    this.cfg = data
    // Значения по умолчанию для тела, глаз и рта (скрыть их нельзя)
    if (!("body" in this.cfg) || this.cfg["body"] === 0) {
      this.cfg["body"] = this.defaultCfg.body
    }
    if (!("eyes" in this.cfg) || this.cfg["eyes"] === 0) {
      this.cfg["eyes"] = this.defaultCfg.eyes
    }
    if (!("mouth" in this.cfg) || this.cfg["mouth"] === 0) {
      this.cfg["mouth"] = this.defaultCfg.mouth
    }

    for (const [key, value] of Object.entries(this.cfg)) {
      if (value == 0) {
        this.parts[key].style.backgroundImage = "none"
        delete this.cfg[key]
      } else if (this.isHair(key)) {
        this.preloadImg(
          this.parts[key],
          "/avatars/" + key + "/" + value.id + "/default.svg#v" + value.c,
        )
      } else {
        this.preloadImg(
          this.parts[key],
          "/avatars/" + key + "/" + value + "/" + this.state,
        )
      }
    }
  }

  preloadImg(element, imgurl) {
    const preloadImg = new Image()
    preloadImg.onload = () => {
      element.style.backgroundImage = "url(" + imgurl + ")"
    }
    preloadImg.src = imgurl
  }

  /*   loadSave(n) {
    const save = localStorage.getItem("ava" + n)
    if (save) {
      const parsed = this.parse(save)
      if (parsed) {
        this.load(parsed)
      }
    } else {
      console.log("default")
      this.load(this.defaultCfg)
    }
    this.save = n
    localStorage.setItem("save", n)
  } */

  set(type, n = 0, c = null) {
    if (SKINS_TYPES.indexOf(type) >= 0) {
      //const idx = this.types.indexOf(type)
      this.cfg[type] = c != null ? { id: parseInt(n), c: c } : parseInt(n)
      this.load(this.cfg)
      if (CONTEXT == "editor")
        localStorage.setItem("ava", JSON.stringify(this.cfg))
    }
  }

  getSkinAsObject(skinMap) {
    const skinObj = {}

    // MapSchema в Colyseus итерируется как обычная Map или через forEach
    skinMap.forEach((part, key) => {
      // Если у части есть цвет 'c', создаем объект, иначе просто id
      if (part.c) {
        skinObj[key] = { id: part.id, c: part.c }
      } else {
        skinObj[key] = part.id
      }
    })

    return skinObj
  }
}
